module.exports = __webpack_public_path__ + "assets/users.5e989f35.svg";